import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { TraceService, createErrorHandler } from '@sentry/angular';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { AppComponent } from './app.component';
import FormComponent from './form/form.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    FormComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: FormComponent },
      { path: ':id', component: FormComponent }
    ]),
    NgxMaskDirective,
    NgxMaskPipe,
    SharedModule],
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: true,
      }),
    },
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(async () => inject(TraceService)),
  ]
})

export class AppModule { }
